import type { TourDefinition } from '../tours.types';


export const STEP2_CARGA_DOCUMENTOS_TOUR: TourDefinition = {
  id: 'step2_carga_documentos_help',
  //route: '/firmas/firma',
  remember: true,
  steps: [
    {
    element: '[data-tour="upload-dropzone"]',
      popover: {
        title: 'Carga tus documentos',
        description:
          'Arrastra tus archivos aquí o haz clic en el área para seleccionarlos desde tu computadora o celular.',
        side: 'bottom',
        align: 'center',
      },
    },
    {
      element: '[data-tour="upload-rules"]',
        popover: {
          title: 'Requisitos del archivo',
          description:
            'Por ahora solo se permiten archivos PDF y un tamaño máximo de 5 MB por documento.',
          side: 'bottom',
          align: 'start',
        },
    },   
    {
      element: '[data-tour="firma-next"]',
       popover: {
        title: 'Continuar al siguiente paso',
        description:
          'Después de subir los documentos, presiona “Siguiente” para avanzar al paso de selección de participantes.',
        side: 'left',
        align: 'center',
      },
    },
  ],
};
